import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';


const RegisterButton = () => {
  const { t } = useTranslation();

  return (
    <Link
      to="/register"
      className="inline-block px-1 py-3 text-wild-ocean underline text-sm"
    >
      {t('buttons.register')}
    </Link>
  );
}

export default RegisterButton;
